import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const UniversalAssociationsSelectSideNavAccessibilityMessage = ({
  pluralObjectName,
  count
}) => {
  if (count === 1) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "universalAssociationsSelect.accessibility.associations.one",
      options: {
        pluralObjectName
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "universalAssociationsSelect.accessibility.associations.other",
    options: {
      number: count,
      pluralObjectName
    }
  });
};
export default UniversalAssociationsSelectSideNavAccessibilityMessage;